<template>
  <div class="myComponent">
    <el-upload
      ref="upload"
      class="avatar-uploader"
      :action="afterUrl"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      name="imgFile"
    >
      <div v-if="!loading" class="picture-card">
        <div v-if="imgUrl" class="father">
          <img :src="imgUrl" class="avatar">
          <div class="hovers " @click.stop>
            <i class="el-icon-delete del" @click="clickRemove" />
          </div>
        </div>
        <i v-else class="el-icon-plus avatar-uploader-icon" />
      </div>
      <div v-else v-loading="loading" class="avatar border" />

      <div class="showbutton">
        <el-button
          v-if="showButton"
          slot="trigger"
          size="small"
          type="primary"
        >{{ file ? '上传文件' : '上传图片' }}</el-button>
        <div style="flex:1" class="uploadtext" @click.stop />
        <div v-if="!file" class="uploadtext" @click.stop>
          <div class="uploadtext-1">
            建议尺寸{{ size ? size : '1920*450' }}像素
          </div>
          <div class="uploadtext-2">
            支持JPG/JPEG/BMP/GIF/PNG/WEBP格式，大小不超过8M
          </div>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    file: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    },
    itemInfoKey: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      afterUrl:
        window.location.protocol +
        '//10000.165183.com/UserControls/upload_json.ashx?dir=default',
      loading: false
    }
  },

  mounted() {
  },

  methods: {
    handleAvatarSuccess(res, file) {
      if (!res.url) {
        this.$message.error(res.message)
      }
      this.$emit('handleAvatarSuccess', res.url, this.itemInfoKey)
      this.loading = false
    },
    clickRemove() {
      this.$emit('handleAvatarSuccess', '', this.itemInfoKey)
    },
    beforeAvatarUpload(file) {
      const typeList = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/bmp',
        'image/gif',
        'image/webp'
      ]
      const isOk = typeList.includes(file.type)
      const isLt2M = file.size / 1024 < 8000
      if (!this.file) {
        if (!isOk) {
          this.$message.error('上传头像图片只能是 JPG/png 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过500k!')
          return false
        }
        this.loading = true

        return isOk && isLt2M
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.myComponent {
  ::v-deep {
    .avatar-uploader {
      position: relative;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-form-item__label {
      text-align: left !important;
    }
  }
}

.showbutton {
  //空值上传图片的按钮
  position: absolute;
  top: 0;
  left: 207px;
  height: 178px;
  display: flex;
  flex-direction: column;
  width: 94px;
}
.uploadtext {
  cursor: default;
}
.uploadtext-1 {
  width: max-content;
  font-size: 16px;
  color: #999999;
  text-align: left;
}
.uploadtext-2 {
  width: max-content;
  font-size: 14px;
  color: #999999;
  text-align: left;
}
.father {
  position: relative;
  .hovers {
    display: none;
  }
}
.father:hover {
  position: relative;
  .hovers {
    cursor: default;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;
    .del {
      transform: scale(2);
      color: #000;
      cursor: pointer;
    }
  }
}
</style>
